import classNames from 'classnames'
import { JSX } from 'react'

import { ITextareaProps, Textarea } from 'core-components/library/inputs'
import { createComponentFn } from 'onboarding/components/helpers/createComponentFn'
import themesStyles from 'onboarding/components/themes.module.scss'

type TComponentFn = (props: ITextareaProps) => JSX.Element | null

const applyDisabled = (component: TComponentFn) => {
  return (props: ITextareaProps) => {
    const { disabled, classes } = props
    const disabledTheme = disabled ? themesStyles.disabledInput : undefined

    return component({
      ...props,
      classes: { ...classes, root: classNames(classes?.root, disabledTheme) },
    })
  }
}

export const OnboardingTextarea = (props: ITextareaProps) =>
  applyDisabled(createComponentFn(Textarea))(props)
